import { observable } from 'mobx'
import { ResourcesRequest } from '../ResourcesRequest'
import ResourcesStore from '../ResourcesStore'

class CreateMyFolderStore {
  @observable isLoading = false

  create = async data => {
    this.isLoading = true
    await ResourcesRequest.create(data)

    this.isLoading = false

    ResourcesStore.search()
  }

  clearStore = () => {
    this.isLoading = false
  }
}

export default new CreateMyFolderStore()
